$(function () {
  // 初始化
  const hash = location.hash.split("#")[1] || 1;
  $(".app-IndustryVillage-article .tab-list .tab-list-item")
    .eq(hash - 1)
    .addClass("line-hover");
  $(".article-list-item")
    .eq(hash - 1)
    .addClass("show");

  // tab切换
  $(".app-IndustryVillage-article .tab-list .tab-list-item").on(
    "click",
    function () {
      const index = $(".tab-list-item").index(this) + 1;
      if (index == 5) {
        $(".next").css("display", "none");
        $(".prev").css("display", "block");
      } else if (index == 1) {
        $(".prev").css("display", "none");
      } else {
        $(".next").css("display", "block");
        $(".prev").css("display", "block");
      }
      location.hash = index; //切换保存hash值
      $(".tab-list-item").removeClass("line-hover");
      $(".tab-list-item")
        .eq(index - 1)
        .addClass("line-hover");
      $(".article-list-item").removeClass("show");
      $(".article-list-item")
        .eq(index - 1)
        .addClass("show");
    }
  ),
    // 下一篇
    $(".app-IndustryVillage-article .next").on("click", function () {
      // const index = $(".tab-list-item").index(this) + 1;
      const index = Number(location.hash.split("#")[1] || 1) + 1;
      if (index == 5) {
        $(".next").css("display", "none");
        $(".prev").css("display", "block");
      } else {
        $(".next").css("display", "block");
        $(".prev").css("display", "block");
      }
      location.hash = index; //切换保存hash值
      $(".tab-list-item").removeClass("line-hover");
      $(".tab-list-item")
        .eq(index - 1)
        .addClass("line-hover");
      $(".article-list-item").removeClass("show");
      $(".article-list-item")
        .eq(index - 1)
        .addClass("show");
    });

  // 上一篇
  $(".app-IndustryVillage-article .prev").on("click", function () {
    const index = Number(location.hash.split("#")[1] || 1) - 1;
    if (index != 5) {
      $(".next").css("display", "block");
    }
    if (index == 1) {
      $(".prev").css("display", "none");
    } else {
      $(".prev").css("display", "block");
    }
    location.hash = index; //切换保存hash值
    $(".tab-list-item").removeClass("line-hover");
    $(".tab-list-item")
      .eq(index - 1)
      .addClass("line-hover");
    $(".article-list-item").removeClass("show");
    $(".article-list-item")
      .eq(index - 1)
      .addClass("show");
  });
  //banner图片轮播
  // $(function () {
  //   const $imgs = $(".village-header-banner-wrap .img-swiper-item");
  //   if ($imgs.length > 1) {
  //     const $pagination = $('<div class="pagination-wrap"></div>');
  //     for (let i = 0; i < $imgs.length; i++) {
  //       $pagination.append(
  //         '<div class="pagination-item"><i class="white-box"></i></div>'
  //       );
  //     }
  //     $(".village-header-banner-wrap .img-swiper-list").after($pagination);
  //   }
  //   //
  //   const $paginations = $(
  //     ".village-header-banner-wrap .pagination-wrap .pagination-item"
  //   );
  //   //
  //   let activeIndex = 0;
  //   const activeSync = () => {
  //     if (!$imgs.get(activeIndex)) {
  //       activeIndex = 0;
  //     }
  //     $imgs.removeClass("active").eq(activeIndex).addClass("active");
  //     $paginations.removeClass("active").eq(activeIndex).addClass("active");
  //   };
  //   setTimeout(activeSync, 100);
  //   $paginations.on("click", function () {
  //     activeIndex = $paginations.index($(this));
  //     activeSync();
  //     restartInterval();
  //   });
  //   let interval = null;
  //   const restartInterval = () => {
  //     clearInterval(interval);
  //     interval = setInterval(() => {
  //       activeIndex++;
  //       activeSync();
  //     }, 5000);
  //   };
  //   restartInterval();
  // });
});
